import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/vehicleRegistration/history/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/vehicleRegistration/history/detail',
    method: 'get',
    params: data,
  })
}

